// Components, atoms, molecules, organisms
import NewBecomePartnerContainer from './NewBecomePartnerContainer';

export { NewBecomePartnerContainer };

export default NewBecomePartnerContainer;